import { render, staticRenderFns } from "./WarningWalletModal.vue?vue&type=template&id=2c1c195d&scoped=true"
import script from "./WarningWalletModal.vue?vue&type=script&lang=js"
export * from "./WarningWalletModal.vue?vue&type=script&lang=js"
import style0 from "./WarningWalletModal.vue?vue&type=style&index=0&id=2c1c195d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c195d",
  null
  
)

export default component.exports